import { useEffect, useRef, useState } from 'react';

type UseGoogleLoginWithNonceProps = {
  clientId?: string;
  nonce?: string;
  onSuccess: (token: string) => void;
  onError?: (err: unknown) => void;
};

export const useGoogleLoginWithNonce = ({
  clientId,
  nonce,
  onSuccess,
  onError,
}: UseGoogleLoginWithNonceProps) => {
  const initializedRef = useRef(false);

  const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] =
    useState(false);

  useEffect(() => {
    if (
      initializedRef.current ||
      !window.google?.accounts?.id ||
      !clientId ||
      !scriptLoadedSuccessfully ||
      !nonce
    )
      return;

    window.google.accounts.id.initialize({
      client_id: clientId,
      nonce,
      callback: (response) => {
        if (response.credential) {
          onSuccess(response.credential);
        } else {
          onError?.(new Error('Google login failed: no credential'));
        }
      },
    });

    initializedRef.current = true;
  }, [clientId, nonce, onSuccess, onError, scriptLoadedSuccessfully]);

  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://accounts.google.com/gsi/client';
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.onload = () => {
      setScriptLoadedSuccessfully(true);
    };
    scriptTag.onerror = () => {
      setScriptLoadedSuccessfully(false);
    };

    document.body.appendChild(scriptTag);

    return () => {
      document.body.removeChild(scriptTag);
    };
  }, []);

  const login = () => {
    try {
      window.google.accounts.id.prompt(); // Показывает всплывающее окно входа
    } catch (e) {
      onError?.(e as Error);
    }
  };

  return login;
};
